import React, { Component } from 'react';
class NavBar extends Component {
  render(){
    return(
      <nav>
          <h3 className="navText center-align">Miko's Weather App</h3>
      </nav>
      )
  }
}

export default NavBar



// WEBPACK FOOTER //
// ./src/containers/nav_bar.js